import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Quote, Star } from 'lucide-react';
import { testimonials } from '../data/mock';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 bg-white relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#F5C842]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#8B0000]/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-[#F5C842]/20 text-[#8B0000] border-[#F5C842]/30">
            Testimoni Jamaah
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Apa Kata <span className="text-[#8B0000]">Jamaah Kami?</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Kepuasan dan kebahagiaan jamaah adalah prioritas utama kami
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {testimonials.map((testimonial) => (
            <Card 
              key={testimonial.id}
              className="group hover:shadow-2xl transition-all duration-500 border-2 border-gray-100 hover:border-[#F5C842] relative overflow-hidden"
            >
              {/* Background Image */}
              <div className="absolute inset-0 opacity-5">
                <img
                  src={testimonial.image}
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>

              <CardContent className="p-6 relative z-10">
                {/* Quote Icon */}
                <div className="mb-4">
                  <Quote className="w-10 h-10 text-[#8B0000]/20" />
                </div>

                {/* Rating */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-[#F5C842] text-[#F5C842]" />
                  ))}
                </div>

                {/* Comment */}
                <p className="text-gray-700 mb-6 leading-relaxed italic">
                  "{testimonial.comment}"
                </p>

                {/* Divider */}
                <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent mb-6"></div>

                {/* Author Info */}
                <div>
                  <h4 className="font-bold text-gray-900 text-lg mb-1">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-gray-600 mb-1">{testimonial.location}</p>
                  <p className="text-xs text-[#8B0000] font-medium">
                    {testimonial.package} • {testimonial.date}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Stats Section */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {[
            { number: '10+', label: 'Tahun Pengalaman' },
            { number: '1000+', label: 'Jamaah Terlayani' },
            { number: '50+', label: 'Keberangkatan/Tahun' },
            { number: '4.9/5', label: 'Rating Kepuasan' }
          ].map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-[#8B0000] mb-2">
                {stat.number}
              </div>
              <div className="text-sm text-gray-600">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
